import React, { createContext, useContext, useState, useCallback } from 'react';

const UnsavedChangesContext = createContext(null);

export function UnsavedChangesProvider({ children }) {
  const [isDirty, setIsDirty] = useState(false);

  const setDirty = useCallback((value) => {
    setIsDirty(value);
  }, []);

  return (
    <UnsavedChangesContext.Provider value={{ isDirty, setDirty }}>
      {children}
    </UnsavedChangesContext.Provider>
  );
}

export function useUnsavedChangesContext() {
  const ctx = useContext(UnsavedChangesContext);
  if (!ctx) {
    throw new Error('useUnsavedChangesContext must be used within UnsavedChangesProvider');
  }
  return ctx;
}
